module.exports = __webpack_public_path__ + "static/media/html.07d15e64.png";